export default ({to, form, router, next}) => {
	
    const token = localStorage.getItem('token') || null
    if (token) {
        return router.push({ name: 'home-index' });
    }
    return next();
}

